<script setup lang="ts">
  const emit = defineEmits(['apply', 'cancel']);
</script>

<template>
  <div class="flex justify-end gap-2.5 p-4 border-t border-gray-02">
    <button
      class="px-4 py-3 border border-gray-03 text-gray-03 rounded-lg font-medium"
      @click="emit('cancel')"
    >
      Cancelar
    </button>
    <button
      class="px-4 py-3 bg-[var(--theme-secondary)] text-white rounded-lg font-medium"
      @click="emit('apply')"
    >
      Aplicar data
    </button>
  </div>
</template>
